module.exports = __webpack_public_path__ + "img/027-american-samoa.ebb67d84.svg";